import { ShoppingBag, ShoppingCart } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { useCart } from "@/contexts/CartContext";
import { useToast } from "@/hooks/use-toast";
import { Link } from "react-router-dom";
import { products } from "@/data/products";

const StoreSection = () => {
  const { addItem } = useCart();
  const { toast } = useToast();

  const handleAddToCart = (product: typeof products[0]) => {
    addItem({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
    });
    toast({
      title: "Added to cart",
      description: `${product.name} has been added to your cart.`,
    });
  };

  return (
    <section id="store" className="py-16 md:py-20 bg-card scroll-mt-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-[32px] md:text-[36px] font-bold mb-4 tracking-[0.02em] uppercase text-foreground">MERCH</h2>
          <p className="font-medium text-muted-foreground text-lg max-w-2xl mx-auto">
            Show your support with exclusive Park Row merchandise
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {products.map((item) => (
            <Card 
              key={item.id} 
              className="group overflow-hidden border-border bg-background hover:border-primary transition-all duration-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
                  loading={item.id > 3 ? "lazy" : "eager"}
                  decoding="async"
                />
              </div>
              <CardContent className="p-6">
                <h3 className="text-lg font-bold mb-3 uppercase tracking-[0.02em] text-foreground">{item.name}</h3>
                <div className="flex items-center justify-between">
                  <span className="text-xl font-bold text-foreground">${item.price.toFixed(2)}</span>
                  <Button 
                    onClick={() => handleAddToCart(item)}
                    className="bg-primary hover:bg-primary/90 text-primary-foreground font-bold tracking-[0.03em] uppercase text-[14px] transition-colors duration-300 gap-2"
                  >
                    <ShoppingCart className="h-4 w-4" />
                    ADD TO CART
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link to="/shop">
            <Button variant="outline" size="lg" className="font-bold tracking-wider">
              <ShoppingBag className="h-5 w-5 mr-2" />
              VIEW FULL STORE
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default StoreSection;
